<template>
    <div class="e-card e-rounding shadow-sm">
        <h1 class="h3">{{ $t('preview.stockmix') }}</h1>
        <Loader v-if="loading" />
        {{ $t('preview.stockmix.info') }}
      <div class="custom-control custom-switch">
        <input type="checkbox" v-model="showPrices" class="custom-control-input" role="switch" id="showPrices">
        <label class="custom-control-label" for="showPrices">{{ $t('checkbox.showRecipePrices') }}</label>
      </div>
        <p></p>
        <div v-if="!loading">
        <div v-for="item in items" v-bind:key="item.mcode">
          <div style="height: 20px"></div>
          <b>M{{item.mcode}} {{item.itemName}}</b>
          <p></p>
          <div v-if="showPrices">
          {{ $t('form.price')}}: {{item.priceStr!==null?item.priceStr:'?'}}
          <br>
          {{ $t('form.purchasePrice')}}: {{item.costStr}}
            <p></p>
          </div>
          <table class="table table-hover e-table--responsive">
            <thead>
            <tr>
              <th style="width: 150px;overflow: hidden;">{{ $t('stock.table.sku') }}</th>
              <th>{{ $t('stock.table.name') }}</th>
              <th>{{ $t('stock.change') }}</th>
              <th>{{ $t('form.unit') }}</th>
              <th class="price" v-if="showPrices">{{ $t('form.purchasePrice')}}</th>
            </tr>
            </thead>
            <tbody>
          <tr v-for="record in item.records" v-bind:key="record.sku">
            <td :data-title="$t('stock.table.sku')">{{record.sku}}</td>
            <td :data-title="$t('stock.table.name')"> {{record.itemName}}</td>
            <td :data-title="$t('stock.change')"> {{record.stockChangeStr}} </td>
            <td :data-title="$t('form.unit')">{{record.unitStr}}</td>
            <td :data-title="$t('form.purchasePrice')" class="price" v-if="showPrices">{{record.costStr}}</td>
            </tr>
            </tbody>
          </table>
        </div>
        </div>

    </div>
</template>

<script>
    import Loader from "@/components/Loader"

    export default {
        name: 'StockMixPreview',
        components: { Loader },

        data: function () {
            return {
                items: [],
                loading: false,
                showPrices: false
            }
        },

        mounted: function () {
          this.refresh();
        },

        methods: {
            refresh: function () {
                const vm = this;
                vm.loading = true;
                this.$http.post('/item/get-all-stock-mix-records')
                    .then(function (response) {
                        vm.items = response.data.items;
                        vm.loading = false;
                    });
            }
        }
    }
</script>

<style>
.price {
  text-align: right;
}
</style>

